'use client';

import { ReactNode } from 'react';
import {
  ArrowRightStartOnRectangleIcon,
  InboxIcon,
  ShieldCheckIcon,
  UserIcon,
  LightBulbIcon,
  Cog8ToothIcon,
} from '@heroicons/react/24/outline';

import { UserAvatar } from '../components';
import { cn } from '../lib';

import {
  DropdownTw,
  DropdownItemTw,
  DropdownLabelTw,
  DropdownMenuTw,
  DropdownButtonTw,
  DropdownDividerTw,
  Navbar,
  NavbarDivider,
  NavbarItem,
  NavbarSection,
  SidebarTrigger,
} from '../ui';

import { AppBreadcrumb } from './AppBreadcrumb';
import { TBreadcrumb } from './types';

function AppNavBarEndActions() {
  return (
    <NavbarSection className="pe-4">
      <NavbarItem aria-label="Inbox" href="/inbox">
        <InboxIcon />
      </NavbarItem>
      <DropdownTw>
        <DropdownButtonTw as={NavbarItem}>
          {/* <Avatar square src="/profile-photo.jpg" /> */}

          <UserAvatar
            size="size-4 rounded-md !border-0 cursor-pointer"
            variant={{
              type: 'dicebear-avatar',
              name: 'Sowed Castelli',
            }}
          />
        </DropdownButtonTw>
        <DropdownMenuTw anchor="bottom end" className="min-w-64">
          <DropdownItemTw href="/my-profile">
            <UserIcon />
            <DropdownLabelTw>My profile</DropdownLabelTw>
          </DropdownItemTw>
          <DropdownItemTw href="/settings">
            <Cog8ToothIcon />
            <DropdownLabelTw>Settings</DropdownLabelTw>
          </DropdownItemTw>
          <DropdownDividerTw />
          <DropdownItemTw href="/privacy-policy">
            <ShieldCheckIcon />
            <DropdownLabelTw>Privacy policy</DropdownLabelTw>
          </DropdownItemTw>
          <DropdownItemTw href="/share-feedback">
            <LightBulbIcon />
            <DropdownLabelTw>Share feedback</DropdownLabelTw>
          </DropdownItemTw>
          <DropdownDividerTw />
          <DropdownItemTw href="/logout">
            <ArrowRightStartOnRectangleIcon />
            <DropdownLabelTw>Sign out</DropdownLabelTw>
          </DropdownItemTw>
        </DropdownMenuTw>
      </DropdownTw>
    </NavbarSection>
  );
}

interface IAppStickyNavbarProps {
  actionsStart?: ReactNode;
  actionsEnd?: ReactNode;
  breadcrumbs?: TBreadcrumb[];
  filterOptions?: ReactNode;
  subNavBarContent?: ReactNode;
  subNavBarContentClass?: string;
}

/**
 * -----------------------------------------------------------------------------
 * The main page header component that can be used to customize the app navbar
 * content like search options, toggle, breadcrumbs, filters, etc.
 */
export function AppStickyNavbar({
  actionsStart,
  actionsEnd,
  breadcrumbs,
  filterOptions,
  subNavBarContent,
  subNavBarContentClass,
}: IAppStickyNavbarProps) {
  return (
    <div className="sticky top-0 z-40 flex shrink-0">
      <div className="w-full bg-white dark:bg-neutral-900">
        <Navbar className="border-b-[0.5] ps-4">
          <SidebarTrigger className="-ml-1 shrink-0" />
          <NavbarDivider className="max-lg:hidden" />
          {actionsStart}
          {breadcrumbs ? <AppBreadcrumb items={breadcrumbs} /> : null}
          {filterOptions}
          {actionsEnd ? <AppNavBarEndActions /> : null}
        </Navbar>

        {subNavBarContent ? (
          <div
            className={cn(
              `
              flex w-full flex-row gap-2 border-b-[0.5] bg-gray-200/20 py-1.5
              ps-4 dark:bg-neutral-950/20
            `,
              subNavBarContentClass
            )}
          >
            {subNavBarContent}
          </div>
        ) : null}
      </div>
    </div>
  );
}
